var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/header/menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,20 C14.5522847,20 15,20.4477153 15,21 C15,21.5128358 14.6139598,21.9355072 14.1166211,21.9932723 L14,22 L7,22 C6.44771525,22 6,21.5522847 6,21 C6,20.4871642 6.38604019,20.0644928 6.88337887,20.0067277 L7,20 L14,20 Z M23,14 C23.5522847,14 24,14.4477153 24,15 C24,15.5128358 23.6139598,15.9355072 23.1166211,15.9932723 L23,16 L7,16 C6.44771525,16 6,15.5522847 6,15 C6,14.4871642 6.38604019,14.0644928 6.88337887,14.0067277 L7,14 L23,14 Z M23,8 C23.5522847,8 24,8.44771525 24,9 C24,9.51283584 23.6139598,9.93550716 23.1166211,9.99327227 L23,10 L7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.48716416 6.38604019,8.06449284 6.88337887,8.00672773 L7,8 L23,8 Z",
    id: "menu",
    fill: "#192233"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6a6e0fab.svg";
export { ForwardRef as ReactComponent };